import React from 'react'
import { SvgIcon, SvgIconProps } from '@material-ui/core'
import { SupportAgent } from 'assets'

const SupportAgentIcon = (props: SvgIconProps) => <SvgIcon component={SupportAgent} {...props} />

export default SupportAgentIcon
